// extracted by mini-css-extract-plugin
module.exports = {"logo":"RacLogo_logo__yQEu1","dark_bg":"RacLogo_dark_bg__u8kBR","light_bg":"RacLogo_light_bg__ChLI9"};